import React from "react";
import { siteConfig } from "../siteConfig";

/*
  SVG placeholder logo — used until a real logo file is placed in
  public/assets/logo.png and siteConfig.logo is set to "/assets/logo.png".

  Layout: [green circle icon] [FirstWord] / [rest of name in green]
  All values driven by siteConfig so it auto-updates when the client's
  business name or brand colors change.
*/

const LogoMark = ({ scrolled = false }) => {
  // Split business name: e.g. "Evergreen Outdoor Living" → "Evergreen" + "Outdoor Living"
  const words = siteConfig.businessName.trim().split(/\s+/);
  const primary = words[0];
  const secondary = words.slice(1).join(" ");

  const textColor = scrolled ? siteConfig.colors.dark : "#ffffff";

  return (
    <div className="flex items-center gap-2.5 select-none">

      {/* ── Icon mark — green circle with leaf ── */}
      <svg
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Circle background */}
        <circle cx="19" cy="19" r="19" fill={siteConfig.colors.primary} />

        {/* Leaf body — two bezier arcs meeting at tip and base */}
        <path
          d="M19 9
             C13 9 10 14.5 11.5 20
             C13 25.5 19 28 19 28
             C19 28 25 25.5 26.5 20
             C28 14.5 25 9 19 9 Z"
          fill="white"
          opacity="0.95"
        />

        {/* Center vein */}
        <line
          x1="19" y1="13"
          x2="19" y2="26"
          stroke={siteConfig.colors.primary}
          strokeWidth="1.2"
          strokeLinecap="round"
          opacity="0.5"
        />

        {/* Stem */}
        <line
          x1="19" y1="28"
          x2="19" y2="33"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
          opacity="0.8"
        />
      </svg>

      {/* ── Wordmark ── */}
      <div className="leading-none">
        <div
          className="font-display font-black text-[1.05rem] tracking-tight leading-tight transition-colors duration-300"
          style={{ color: textColor }}
        >
          {primary}
        </div>
        {secondary && (
          <div
            className="font-semibold text-[0.65rem] uppercase tracking-[0.12em] leading-tight mt-0.5 transition-colors duration-300"
            style={{ color: siteConfig.colors.primary }}
          >
            {secondary}
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoMark;
